<template>
  <section class="item-types">
    <div id="top-page" class="tw-hidden-"></div>
    <ul v-if="breadcrumbs" id="breadcrumbs" class="breadcrumbs ct mt-3">
        <li class="breadcrumbs__item">
          <a>{{currentPosition.location}}</a>
        </li>
        <li class="breadcrumbs__item">
            <a>{{currentPosition.wdt + 'x' + currentPosition.htl + ' - ' + currentPosition.item.type_name}}</a>
        </li>
        <li class="breadcrumbs__item">
            <a>{{currentPosition.item.style_name}}</a>
        </li>
        <li class="breadcrumbs__item">
            <a>{{currentPosition.item.grade_name}}</a>
        </li>
    </ul>
    <div class="row" id="default-section">
      <div class="col-12">
        <div class="divider">
          <div class="divider">
            <span class="divider__text text_green">Default options</span>
          </div>
        </div>
      </div>

      <div class="col-md-2 col-sm-4 col-6">
        <div class="box" @click="toLocation()">
          <p class="box__imgWrap">
            <img class="box__img" src="../../../assets/img/png/icon-set_location.png" alt="Location">
          </p>
          <p class="text_default box__title">Location</p>

        </div>
      </div>

      <div class="col-md-2 col-sm-4 col-6">
        <div class="box" @click="toType()">
          <p class="box__imgWrap">
            <img class="box__img" src="../../../assets/img/png/dimensions.png" alt="Dimensions">
          </p>
          <p class="text_default box__title">Dimensions</p>

        </div>
      </div>

    <div class="col-md-2 col-sm-4 col-6">
        <div class="box" @click="toFrameColour()">
            <div class=" box__imgWrap">
                <div v-if="currentPosition.colour.image" class="h-100 colours colour_box">
                  <img :src="currentPosition.colour.image_url"  class="colour-image" alt="Frame colour"/>
                </div>
                <img v-else class="box__img" src="../../../assets/img/png/colour.png" alt="Colour"/>
            </div>
            <p class="text_default box__title">
                <span>Frame Colour</span>
                <br>
                <span>{{colourName}}</span>
            </p>

        </div>
    </div>

    <div class="col-md-2 col-sm-4 col-6" v-if="currentPosition.has_insert && !currentPosition.has_only_colour">
        <div class="box" @click="toInsertColour()">
          <div class=" box__imgWrap">
            <div v-if="currentPosition.insert_colour.image" class="h-100 colours colour_box">
              <img :src="currentPosition.insert_colour.image_url"  class="colour-image" alt="Insert colour"/>
            </div>
            <img v-else class="box__img" src="../../../assets/img/png/colour.png" alt="Colour"/>
          </div>
            <p class="text_default box__title">
                <span>Insert Colour</span>
                <br>
                <span>{{insertColourName}} <span v-if="currentPosition.insert_colour.is_same_as_frame"> (same as frame)</span> </span>
            </p>

        </div>
    </div>

      <div class="col-md-2 col-sm-4 col-6"
           v-for="(item, index) in options.default"
           :key="item.id"
           :id="`available-option-${kebabCase(item.name)}`"
      >
        <div class="box" @click="toOptions(index, item)"
             :class="{
             'box_opacity' : !item.available,
             'box_incompatible': item.incompatible,
             'box_incomplete': item.is_incomplete,
             disabled: !item.available,
             }">

          <p class="box__imgWrap">
            <img class="box__img" :src="item.icon" :alt="item.name">
          </p>
          <p class="text_default box__title"
             :class="{'text_red': item.is_incomplete}"
          >{{item.name}}</p>
        </div>
      </div>
      <div class="col-12" v-if="options.default.length === 0">
        <p class="text text_green text_italic">No options to configure</p>
      </div>
    </div>

    <div id="available-section">
    <div class="row">
      <div class="col-12">
        <div class="divider">
          <span class="divider__text text_green">Available options</span>
        </div>
      </div>

      <div class="col-md-2 col-sm-4 col-6"
           v-for="(item, index) in options.available"
           :key="item.id"
      >
        <div class="box" @click="toOptions(index, item)"
             :class="{
             'box_opacity' : !item.available,
             'box_incomplete': item.is_incomplete,
             'box_incompatible': item.incompatible,
             disabled: !item.available,
             }">
          <p class="box__imgWrap">
            <img class="box__img" :src="item.icon" :alt="item.name">
          </p>
          <p class="text_default box__title"
             :class="{'text_red': item.is_incomplete}"
          >{{item.name}}</p>
        </div>
      </div>
      <div class="col-12" v-if="options.available.length === 0">
        <p class="text text_green text_italic">No options to configure</p>
      </div>
    </div>
    </div>
    <!--<price-options v-if="!package && !set"></price-options>-->

    <div class="row" v-if="incomplete.length > 0">
      <div class="col-12">
        <p class="text_red">Please check options: <span v-for="el in incomplete" :key="el">{{`${el} `}}</span></p>
      </div>
    </div>

    <transition name="fade" v-if="midrail_mullion_reset">
      <div class="modal modal_wrap">
        <div class="modal_popup">
          <p  class="text text_white" v-if="conflict == 'MULL'">
            This item only allows Midrail OR Mullion. Midrails already set up. Adding Mullion will remove Midrails. Do you wish to proceed?
          </p>
          <p  class="text text_white" v-else>
            This item only allows Midrail OR Mullion. Mullions already set up. Adding Midrail will remove Mullions. Do you wish to proceed?
          </p>
          <div class="justify-content-between">
            <button class="btn btn_transparent" @click="proceedToOption">Yes</button>
            <button class="btn btn_transparent" @click="close">No</button>
          </div>
        </div>
      </div>
    </transition>

    <div class="tw-hidden">

      <div v-for="(step, index) in steps" :key="step.id">

        <div v-if="step.isModal" class="tw-bg-secondary tw-px-6 tw-pt-6 tw-pb-6 sm:tw-px-10 sm:tw-pt-10 sm:tw-pb-5 tw-rounded-3xl" :id="`step-container-${step.id}`">
          <div class="tw-text-secondary tw-bg-white tw-rounded-lg tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica tw-px-5 tw-py-5">
              <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
                  {{ step.title }}
              </h2>
              <p v-html="step.description">
              </p>

              <ul class="tw-space-y-2 tw-ml-6" v-if="step.items">
                    <li v-for="(item, i) in step.items" :key="i">
                        <svg-icon name="solid/circle" class="tw-text-xs tw-w-1" /> 
                        <span class="tw-text-primary tw-font-bold"> {{item.label}}</span>  {{item.description}}
                    </li>
                </ul>
          </div>

          <!-- <div v-if="index === (currentPath.allOption.steps.length - 1)" class="tw-mt-4 tw-flex tw-space-x-4"> 
            <button @click="backStep" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
              <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
            </button>
            <button @click="saveItem" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
              <svg-icon name="solid/save"/> <span class="tw-ml-2">SAVE ITEM</span>
            </button>
          </div> -->

          <div class="tw-mt-4 tw-flex tw-space-x-4">   
            <button v-for="(action, index) in step.actions" :key="index" @click="() => {action.fn(instance)}" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
              <svg-icon :name="action.icon"/> <span class="tw-ml-2">{{ action.label }}</span>
            </button>

            <!-- <button @click="() => {step.back(instance)}" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
              <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
            </button>
            <button @click="() => {step.next(instance)}" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
              <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
            </button> -->
          </div>
        </div>

        <div v-else class="tw-flex tw-space-x-2 " :id="`step-container-${step.id}`">
            <button v-for="(action, index) in step.actions" :key="index" @click="() => {action.fn(instance)}" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer tw-bg-black tw-bg-opacity-40">
                <svg-icon :name="action.icon"/> <span class="tw-ml-2">{{ action.label }}</span>
            </button>
        </div>
      </div>

      

      <div class="tw-flex tw-space-x-2 ">
        <button @click="backStep" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer tw-bg-black tw-bg-opacity-40">
          <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
        </button>
        <button @click="goNextScreen" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer tw-bg-black tw-bg-opacity-40">
          <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
        </button>
      </div>
    </div>
    <div id="bottom-page" class="tw-hidden-"></div>
  </section>
</template>
<script>

  const PriceOptions = () => import('./PriceOptions');
  import {mapState, mapGetters, mapMutations} from 'vuex';
  import Modal from '@/components/modals/Generic'
  import VueScrollTo from 'vue-scrollto'

  const breadcrumbs = () => import("./../../parts/breadcrumbs");
  export default {
    name: "AllOptions",
    data() {
      return {
        available: [],
        def: [],
        finishPrice: '',
          conflict: '',
          midrail_mullion_reset: false
      }
    },
    props: ['package', 'set', 'editFromSet', 'editFromPackage', 'isEdit', 'backStepInCreate'],

    components: {breadcrumbs, PriceOptions, Modal},   
    mounted() {
      this.startTour()
    },
    beforeDestroy() {
      if(this.tour) this.tour.complete()
    },
    methods: {
      testMethod() {
        console.log('testmethos.............')
      },
      scrollToDefaultOptions() {

        let options = {container: '.container.modal_content.options', easing: 'ease-in', y: true,};                
        VueScrollTo.scrollTo(this.$el, 300, options);

      },
      scrollToAvailableOptions() {
        console.log('avail option')

        let options = {container: '.modal-overflow', easing: 'ease-in', y: true,};

        VueScrollTo.scrollTo('#bottom-page', 300, options);
      },
      kebabCase(val) {
          return _.kebabCase(val)
      },
      goBackToPrevScreen() {
          this.backStepInCreate()
      },
      backStep() {
          this.tour.back()
      },
      goNextScreen() {
          this.next()
      },
      nextStep() {
          this.tour.next()
      },
      saveItem() {
        this.tour.complete()
        this.$store.dispatch('demoWizard/completeTour');
      },
      completeTour() {
        console.log('Complete tour')
      },
      startTour() {
        if(this.tour) this.tour.complete()
            this.$nextTick(() => {
                this.tour = this.$shepherd({
                useModalOverlay: true,
                modalOverlayOpeningPadding: 55,
                arrow: false,
                exitOnEsc: false,
                // stepsContainer: this.$refs.containerRef,
                defaultStepOptions: {
                    canClickTarget: false,
                    classes: 'shepherd-theme-custom',
                    arrow: false,
                    modalOverlayOpeningRadius: 10,
                    modalOverlayOpeningPadding: 1, 
                    popperOptions: {
                    modifiers: [{ name: 'offset', options: { offset: [0, 30, ]} }]
                    },
                    when: {
                      show: () => {
                        this.tour.currentStep._scrollTo()
                      }
                    }
                }
                });

                this.steps.forEach(step => {
                  let options = {
                      text: document.querySelector(`#step-container-${step.id}`),//this.$refs['stepContainer-1'],
                      classes: 'shepherd-theme-custom width-full-',
                      scrollTo: {behavior: 'smooth', inline: 'start'},
                      // when: {
                      //   show: function() {
                      //     console.log('when show................')
                      //     // window.scrollTo(0, 0);
                      //   }
                      // },
                      beforeShowPromise: async () => {
                          await this.$store.dispatch('demoWizard/delayTransition')
                      }
                  }

                  if(step.target) {
                    let el = document.querySelector(step.target)
                    options = {...options, attachTo: { element: el, on: step.targetPosition || 'bottom' }}
                  }
                  console.log('curr step......', step)
                  if(step.stepOptions) {
                    options = {...options, ...step.stepOptions}
                    console.log('custom options', options)

                  }

                  this.tour.addStep(options)
                })
                this.tour.start();
            });
        },
      ...mapMutations('orderPosition', ['goToStep']),
      toFrameColour() {
        this.$store.commit('orderPosition/forceStep', {route: {step: 'Frame Colour'}});
      },
      toInsertColour() {
        this.$store.commit('orderPosition/forceStep', {route: {step: 'Insert Colour'}});
      },
      toType() {
        this.$store.commit('orderPosition/forceStep', {route: {step: 'Type'}});
      },

      toLocation() {
          this.$store.commit('orderPosition/forceStep', {route: {step: 'Location'}});
      },

      toOptions(index, item) {

        if (item.code == 'MIDR' || item.code == 'MULL')
        {
            let opposite = (item.code == 'MIDR' ? 'MULL' : 'MIDR'),
                midr = null,
                mull = null

            _.each(this.options.default, (i) =>{
                if (i.code == 'MIDR')
                  midr = i
                else if (i.code == 'MULL')
                    mull = i
            })

            if (midr && mull)
            {
                let count = 0
                _.each(this.options.default[item.code].settings.values, (i) => {
                    if (i.selected)
                        count++
                })

                if (count == 0)
                {
                    this.conflict = item.code
                    this.midrail_mullion_reset = true
                    return
                }
            }

        }

        if (item.available) {
            this.$store.commit('orderPosition/showOption', item.code);
        }
      },

      close(){
          this.midrail_mullion_reset = false;
      },

      proceedToOption(){
          _.each(this.options.default[this.conflict].settings.values, (i) => {
              i.selected = i.required
          })
          _.each(this.options.default[(this.conflict == 'MIDR' ? 'MULL' : 'MIDR')].settings.values, (i) => {
              i.selected = false
          })

          this.$store.commit('orderPosition/setOption', { option: this.conflict, selection: this.options.default[this.conflict].settings})
          this.$store.commit('orderPosition/setOption', { option: (this.conflict == 'MIDR' ? 'MULL' : 'MIDR'), selection: this.options.default[(this.conflict == 'MIDR' ? 'MULL' : 'MIDR')].settings})


          this.$store.commit('orderPosition/showOption', this.conflict);
      } ,

      toAvailable(index, item) {
        if (!item.incompatible) {
          if (item.typeOpt === 'ACC') {
            this.$parent.itemOptions.ACC = true;
            return true;
          }
          else if (this.editFromSet && this.isEdit || this.editFromPackage && this.isEdit) {
            this.$store.dispatch('packages/editSingleOptionInPackage', {
              option: item.typeOpt,
              packageId: this.packageId
            });
          }
          else {
            if (!item.settings && this.package) {
              this.$store.dispatch('packages/getPackageSingleOption', item.typeOpt);
            }
            else if (!item.settings && this.set) {
              this.$store.dispatch('sets/getToSetOption', item.typeOpt);
            }
            else {
              this.$store.commit('options/setAvailableOptions', item);
            }
          }
        }
        this.checkView(item);
      },

      checkView(item) {
        if (item.option_type === 'available') {
          this.$store.commit('options/setModalView', true);
        }
      },

    },
    watch : {
      currentPath: {
        handler: function(val, oldVal) {
          if(val.cloned) {
            console.log('cloned all options...')
            this.tour.next()
          }
        },
        deep: true
      },
    },

    computed: {
      instance() {
        return this
      },
      steps() {
        return this.$store.getters['demoWizard/getAllOptionConfiguration'].steps
      },
      currentPath() {
        return this.$store.state['demoWizard'].currentPath
      },
      ...mapState('orderItem', ['isUpdate']),
      ...mapState('options', ['incomplete']),


      ...mapState('packages', ['packageId']),
        ...mapState('orderPosition',['currentPosition']),
        options(){
          return this.$store.getters['orderPosition/orderPosition'].options;
        },

      breadcrumbs() {
        return this.$store.getters['app/get']('breadcrumbs');
      },
      colourName() {
        return _.get(this.currentPosition,'colour.name', '')
      },
      insertColourName() {
        return _.get(this.currentPosition,'insert_colour.name', '')
      },
    },

    created() {
    },
  }
</script>

<style scoped lang="scss">
.h-100 {
  height: 100%;
}
.colour-image {
  object-position: center;
  object-fit: cover;
  height: 100%;
}
</style>
